<template>
  <div>
    <BadgeModal
      i="far fa-check-circle orange-icon"
      title="Términos y Responsabilidades"
      class="badge-modal-custom ml-n3"
    />
    <div class="row">
      <div class="col-md-12 panel-agreement-header">
        <label>{{ terms }}</label>
      </div>
      <div
        class="col-md-1 panel-agreement-action-chk"
        :class="{ 'error-box-indicator': isRequired }"
      >
        <input
          v-model="acceptTerms"
          type="checkbox"
          :disabled="disabled"
          class="custom-control checkbox w-50 ml-4 mt-2"
          @change="setAcceptTerms"
        />
      </div>
      <div
        class="col-md-11 panel-agreement-action"
        :class="{ 'error-box-indicator': isRequired }"
      >
        <label class="mt-2">Acepto los términos y responsabilidades</label>
      </div>
    </div>
    <p v-if="isRequired" class="text text-danger ml-n3 mt-1">
      <em class="far fa-exclamation-triangle text-danger mr-2" />
      Favor certificar los términos y responsabilidades
    </p>
  </div>
</template>

<script>
import BadgeModal from '@/components/common/page/badge/BadgeModal';
import resourcesService from '@/services/resources.js';
export default {
  name: 'ControversyAgreement',
  props: {
    isRequired: {
      type: Boolean,
      default: () => true,
    },
    isTermsAccepted: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      terms: '',
      resources: [],
      acceptTerms: this.isTermsAccepted,
    };
  },
  created() {
    this.loadResources();
  },
  components: {
    BadgeModal,
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(['0502']);
    },
    setAcceptTerms(e) {
      this.$emit('termsChecked', e.target.checked);
    },
  },
};
</script>

<style scoped>
.panel-agreement-header {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
  padding: 20px;
}

.panel-agreement-action-chk {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 0px 0px 0px 5px;
  opacity: 1;
  padding: 20px;
}

.panel-agreement-action {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 0px 0px 5px 0px;
  opacity: 1;
  padding: 20px;
}

.custom-checkbox {
  position: absolute;
  left: 37px;
}

.badge-modal-custom >>> i {
  font-size: 20pt;
}

.error-box-indicator {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
  opacity: 1;
}

.error-box-indicator input[type='checkbox'] {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
</style>
